// extracted by mini-css-extract-plugin
module.exports = {"page":"Login_page__3sp2O","spacer":"Login_spacer__1wBZA","forgot":"Login_forgot__3ae7d","header":"Login_header__ehUb-","logo":"Login_logo__3dScP"};